import { ToastVariant } from "ds/components/ToastNew";
import { FlashEvent } from "types/FlashMessage";

export const DEFAULT_TIMEOUT = 5000;

export const getMessageTimeout = (
  flashEvent: FlashEvent,
  defaultTimeout: number = DEFAULT_TIMEOUT
) => {
  // if a timeout is explicitly set, use that
  if (flashEvent.timeout !== undefined) {
    return flashEvent.timeout;
  }

  // If has action or error, there should be no timeout
  if (
    (flashEvent.actionCallback && flashEvent.actionTitle) ||
    flashEvent.variant === ToastVariant.Error
  ) {
    return undefined;
  }

  return defaultTimeout;
};
